'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAppleWebKitBrowser;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TUNE-11677 - fix stream restarts in Apple WebKit browsers
// TUNE-12337 - replace identification strategy with `navigator.vendor`
//
// Detect macOS Safari and iOS browsers
// (Apple requires all browsers in iOS to use the affected WebKit)
// https://developer.apple.com/app-store/review/guidelines/#2.5.6

/* eslint-disable no-undef */
function isAppleWebKitBrowser() {
  var vendor = (0, _get2.default)(window, 'navigator.vendor', '');
  return (/apple/i.test(vendor)
  );
}
/* eslint-enable no-undef */
//# sourceMappingURL=isAppleWebkitBrowser.js.map